// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_owner.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { User } from "../../user/v1/user";
/**
 * @generated from protobuf message c1.api.app.v1.AppOwnerRef
 */
export interface AppOwnerRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppOwnersRequest
 */
export interface SearchAppOwnersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppOwnerRef refs = 4;
     */
    refs: AppOwnerRef[];
    /**
     * @generated from protobuf field: repeated string user_ids = 5;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppOwnersResponse
 */
export interface SearchAppOwnersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1;
     */
    list: User[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * Search App Owners by a few properties.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppOwnersRequest
 */
export interface ListAppOwnersRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppOwnersResponse
 */
export interface ListAppOwnersResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1;
     */
    list: User[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * Empty request body. Just placeholder for the add app owner request which uses URL values for input.
 *
 * @generated from protobuf message c1.api.app.v1.AddAppOwnerRequest
 */
export interface AddAppOwnerRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
}
/**
 * Empty response with a status code indicating success
 *
 * @generated from protobuf message c1.api.app.v1.AddAppOwnerResponse
 */
export interface AddAppOwnerResponse {
}
/**
 * RemoveAppOwnerRequest is the request body for removing an app owner. It uses URL values for input.
 *
 * @generated from protobuf message c1.api.app.v1.RemoveAppOwnerRequest
 */
export interface RemoveAppOwnerRequest {
    /**
     * App ID of the app to remove the owner from.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * User ID of the user to remove as an owner.
     *
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.app.v1.RemoveAppOwnerResponse
 */
export interface RemoveAppOwnerResponse {
}
/**
 * The request message for setting the app owners.
 *
 * @generated from protobuf message c1.api.app.v1.SetAppOwnersRequest
 */
export interface SetAppOwnersRequest {
    /**
     * The app_id field for the app to set the owners of.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The user_ids field for the users to set as an owner of the app.
     *
     * @generated from protobuf field: repeated string user_ids = 2;
     */
    userIds: string[];
}
/**
 * The empty response message for setting the app owners.
 *
 * @generated from protobuf message c1.api.app.v1.SetAppOwnersResponse
 */
export interface SetAppOwnersResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppOwnerIDsRequest
 */
export interface ListAppOwnerIDsRequest {
    /**
     * The app_id field for the app to list owners of.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * The response message for listing app owners IDs.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppOwnerIDsResponse
 */
export interface ListAppOwnerIDsResponse {
    /**
     * The list of owner IDs for the app.
     *
     * @generated from protobuf field: repeated string user_ids = 1;
     */
    userIds: string[];
}
/**
 * The request message for deleting app owners.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppOwnersRequest
 */
export interface DeleteAppOwnersRequest {
    /**
     * The app_id field for the app to remove the owner of.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The user_ids field for the users to set as an owner of the app.
     *
     * @generated from protobuf field: repeated string user_ids = 2;
     */
    userIds: string[];
}
/**
 * the empty response message for deleting app owners.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppOwnersResponse
 */
export interface DeleteAppOwnersResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class AppOwnerRef$Type extends MessageType<AppOwnerRef> {
    constructor() {
        super("c1.api.app.v1.AppOwnerRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppOwnerRef
 */
export const AppOwnerRef = new AppOwnerRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppOwnersRequest$Type extends MessageType<SearchAppOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppOwnersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppOwnerRef },
            { no: 5, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppOwnersRequest
 */
export const SearchAppOwnersRequest = new SearchAppOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppOwnersResponse$Type extends MessageType<SearchAppOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppOwnersResponse
 */
export const SearchAppOwnersResponse = new SearchAppOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppOwnersRequest$Type extends MessageType<ListAppOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppOwnersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppOwnersRequest
 */
export const ListAppOwnersRequest = new ListAppOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppOwnersResponse$Type extends MessageType<ListAppOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppOwnersResponse
 */
export const ListAppOwnersResponse = new ListAppOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAppOwnerRequest$Type extends MessageType<AddAppOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.AddAppOwnerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAppOwnerRequest
 */
export const AddAppOwnerRequest = new AddAppOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAppOwnerResponse$Type extends MessageType<AddAppOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.AddAppOwnerResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAppOwnerResponse
 */
export const AddAppOwnerResponse = new AddAppOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppOwnerRequest$Type extends MessageType<RemoveAppOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.RemoveAppOwnerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAppOwnerRequest
 */
export const RemoveAppOwnerRequest = new RemoveAppOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppOwnerResponse$Type extends MessageType<RemoveAppOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.RemoveAppOwnerResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAppOwnerResponse
 */
export const RemoveAppOwnerResponse = new RemoveAppOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppOwnersRequest$Type extends MessageType<SetAppOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.SetAppOwnersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App_Owner" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppOwnersRequest
 */
export const SetAppOwnersRequest = new SetAppOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppOwnersResponse$Type extends MessageType<SetAppOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.SetAppOwnersResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppOwnersResponse
 */
export const SetAppOwnersResponse = new SetAppOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppOwnerIDsRequest$Type extends MessageType<ListAppOwnerIDsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppOwnerIDsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppOwnerIDsRequest
 */
export const ListAppOwnerIDsRequest = new ListAppOwnerIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppOwnerIDsResponse$Type extends MessageType<ListAppOwnerIDsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppOwnerIDsResponse", [
            { no: 1, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppOwnerIDsResponse
 */
export const ListAppOwnerIDsResponse = new ListAppOwnerIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppOwnersRequest$Type extends MessageType<DeleteAppOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppOwnersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppOwnersRequest
 */
export const DeleteAppOwnersRequest = new DeleteAppOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppOwnersResponse$Type extends MessageType<DeleteAppOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAppOwnersResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppOwnersResponse
 */
export const DeleteAppOwnersResponse = new DeleteAppOwnersResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppOwners
 */
export const AppOwners = new ServiceType("c1.api.app.v1.AppOwners", [
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/owners", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "AppOwners", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App Owner", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: ListAppOwnersRequest, O: ListAppOwnersResponse },
    { name: "ListOwnerIDs", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/ownerids", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App_Owner", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "App Owner" }] } }, I: ListAppOwnerIDsRequest, O: ListAppOwnerIDsResponse },
    { name: "Set", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/apps/{app_id}/owners", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App_Owner" }], group: "App Owner" }] } }, I: SetAppOwnersRequest, O: SetAppOwnersResponse },
    { name: "Add", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/owners/{user_id}", group: "App Owner" }] } }, I: AddAppOwnerRequest, O: AddAppOwnerResponse },
    { name: "Remove", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/owners/{user_id}", group: "App Owner" }] } }, I: RemoveAppOwnerRequest, O: RemoveAppOwnerResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/owners", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App_Owner" }], group: "App Owner" }] } }, I: DeleteAppOwnersRequest, O: DeleteAppOwnersResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppOwnersSearch
 */
export const AppOwnersSearch = new ServiceType("c1.api.app.v1.AppOwnersSearch", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppOwnersRequest, O: SearchAppOwnersResponse }
]);
